// Mock data for TSI Landing Page
export const mockData = {
  company: {
    name: "Traffic Service International",
    tagline: "Innovative Solutions for Tomorrow's Traffic Management",
    description: "Leading provider of smart traffic technology and IoT solutions in Oman",
    logo: "/logo.png"
  },
  
  hero: {
    title: "Connecting Cities Through Leading Edge Technology",
    subtitle: "Harness the power of Artificial Intelligence and Internet of Things to create smarter, safer, and more connected urban environments",
    cta: "Discover Our Solutions",
    backgroundImage: "https://images.unsplash.com/photo-1606813456328-bbf1ae3759ee",
    backgroundVideo: "https://videos.pexels.com/video-files/3191294/3191294-uhd_2560_1440_25fps.mp4",
    fallbackImage: "https://images.unsplash.com/photo-1644329770639-1a20809b82a3"
  },

  services: [
    {
      id: 1,
      title: "Traffic Enforcement Systems",
      description: "Advanced LIDAR speed enforcement with 75-meter operational range. Tracks multiple vehicles across all lanes, including during lane changes and heavy traffic conditions.",
      icon: "Camera",
      image: process.env.PUBLIC_URL+'/Website_Work/02_Traffic_Enforcement/Slide1.JPG',
      features: ["75m Range Detection", "Multi-lane Monitoring", "Mobile Solutions", "Real-time Violations"]
    },
    {
      id: 2,
      title: "City Monitoring Systems",
      description: "360-degree AI cameras on traffic poles providing real-time data transmission. Seamlessly connects with control rooms for optimized traffic management.",
      icon: "Eye",
      image: process.env.PUBLIC_URL+'/Website_Work/03_City_Monitoring/01_Final_one.jpg',
      features: ["360° Coverage", "AI Integration", "Real-time Data", "Traffic Optimization"]
    },
    {
      id: 3,
      title: "Light Bar",
      description: "High-performance LED light bars for vehicles and infrastructure. Energy-efficient lighting solutions with customizable configurations and weather-resistant design.",
      icon: "BarChart3",
      image: process.env.PUBLIC_URL+"/Website_Work/06_Light_Bar/Light_Bar.png",
      features: ["High Performance", "Customizable Configurations", "Weather Resistant", "Energy Efficient"]
    },
    {
      id: 4,
      title: "Smart Solar Pole",
      description: "Integrated smart poles combining solar power, LED lighting, and IoT sensors. Features wireless charging, environmental monitoring, and smart city connectivity.",
      icon: "Zap",
      image: process.env.PUBLIC_URL+"/Website_Work/05_Smart_Solar_Pole/01_Solar_Smart_Pole.png",
      features: ["Solar Integration", "Wireless Charging", "Environmental Sensors", "Smart Connectivity"]
    },
    {
      id: 5,
      title: "DC Fast EV Charger",
      description: "Rapid electric vehicle charging stations with smart grid integration. Features multiple charging standards, payment systems, and remote monitoring capabilities.",
      icon: "Battery",
      image: process.env.PUBLIC_URL+"/Website_Work/07_DC_Fast_EV_Charger/01_Final_one.png",
      features: ["Rapid Charging", "Smart Grid Integration", "Multiple Standards", "Remote Monitoring"]
    },
    {
      id: 6,
      title: "Facade Lighting",
      description: "Energy-efficient LED technology for monuments, fountains, and bridges. Includes projection mapping for cultural events and tourism enhancement.",
      icon: "Sparkles",
      image: process.env.PUBLIC_URL + "/facade_light.jpeg",
      features: ["Monument Lighting", "Fountain Displays", "Bridge Illumination", "Projection Mapping"]
    },
    {
      id: 7,
      title: "Smart Street Lighting",
      description: "IoT-enabled LED street lights that save 70% energy through direct LED technology and 20% through expert systems. Includes cloud-based scheduling, location-based dimming, and real-time monitoring.",
      icon: "Lightbulb",
      image: process.env.PUBLIC_URL+'/Website_Work/01_Smart_Lighting/A9-Noord-Holland-Netherlands-IZYLUM-EXEDRA-Schreder-11.jpg',
      features: ["70% Energy Savings", "Cloud-based Control", "Real-time Monitoring", "Automated Dimming"]
    },
    {
      id: 8,
      title: "Solar Solutions",
      description: "Eco-friendly solar street lights, benches, and bollards. Sustainable lighting solutions that reduce carbon footprint while providing reliable illumination.",
      icon: "Sun",
      image: process.env.PUBLIC_URL+"/Website_Work/04_Solar_street_light/solar_solution_final.jpg",
      features: ["Carbon Footprint Reduction", "Sustainable Energy", "Low Maintenance", "Weather Resistant"]
    },
    {
      id: 9,
      title: "Battery Power",
      description: "Advanced battery storage solutions for renewable energy integration and backup power for critical traffic infrastructure. Features smart energy management and grid stabilization capabilities.",
      icon: "Battery",
      image: process.env.PUBLIC_URL+"/Website_Work/09_Battary_power/battery.png",
      features: ["Renewable Integration", "24/7 Reliability", "Grid Stabilization", "Emergency Backup"],
      backgroundColor: "bg-gradient-to-br from-blue-50 to-indigo-50"
    }
  ],

  newFeatures: [
    {
      id: 1,
      title: "Energy Saving Solutions",
      description: "Advanced energy management systems that optimize power consumption across all infrastructure components with intelligent algorithms.",
      icon: "Battery",
      benefits: ["Up to 90% Energy Reduction", "Smart Grid Integration", "Predictive Maintenance", "Cost Optimization"]
    },
    {
      id: 2,
      title: "Energy Storage Systems",
      description: "Cutting-edge battery storage solutions for renewable energy integration and backup power for critical traffic infrastructure.",
      icon: "HardDrive",
      benefits: ["Renewable Integration", "24/7 Reliability", "Grid Stabilization", "Emergency Backup"]
    },
    {
      id: 3,
      title: "AI Traffic Intelligence",
      description: "Machine learning algorithms for traffic pattern analysis, congestion prediction, and autonomous traffic signal optimization.",
      icon: "Brain",
      benefits: ["Predictive Analytics", "Autonomous Control", "Pattern Recognition", "Smart Optimization"]
    }
  ],

  stats: [
    { label: "Projects Delivered", value: "500+", icon: "CheckCircle" },
    { label: "Cities Connected", value: "25+", icon: "MapPin" },
    { label: "Energy Saved", value: "70%", icon: "Zap" },
    { label: "R&D Investment", value: "$1M", icon: "TrendingUp" }
  ],

  testimonials: [
    {
      id: 1,
      name: "Ahmed Al-Rashid",
      position: "Director of Urban Planning",
      organization: "Ministry of Transportation",
      content: "TSI's smart lighting solutions have transformed our city's infrastructure, reducing energy costs by 70% while improving safety.",
      avatar: "AR"
    },
    {
      id: 2,
      name: "Sarah Johnson",
      position: "Smart City Manager",
      organization: "Muscat Municipality",
      content: "The traffic enforcement systems have significantly improved road safety and compliance across our urban areas.",
      avatar: "SJ"
    }
  ],

  video: {
    title: "See Our Technology in Action",
    description: "Watch how TSI is transforming cities with smart technology solutions",
    thumbnail: "https://images.unsplash.com/photo-1578406100567-f605301b0eec",
    url: "https://example.com/videos/solution_preview.mp4"
  },

  companyVideo: {
    title: "TSI Corporate Overview",
    description: "Learn about our company's mission and innovative solutions",
    thumbnail: "https://images.unsplash.com/photo-1644329770639-1a20809b82a3",
    url: "https://example.com/videos/corporate_overview.mp4"
  },

  contact: {
    office: "Building No: 915, office No: 579\nCBD (Abu Dhabi bank) Al Falaj street,\nMuscat, Sultanate of Oman",
    email: "pajanissamyv@tsioman.com",
    phone: "+968 24797849",
    mobile: "+968 955221926",
    social: {
      linkedin: "#",
      twitter: "#",
      facebook: "#"
    }
  },

  careers: {
    openPositions: [
      {
        id: 1,
        title: "Senior IoT Engineer",
        department: "Engineering",
        location: "Muscat, Oman",
        type: "Full-time",
        experience: "3-5 years",
        description: "Lead the development of IoT solutions for smart city infrastructure, including sensor networks, data analytics, and system integration.",
        skills: ["IoT", "Python", "Arduino", "Cloud Computing", "Data Analytics"]
      },
      {
        id: 2,
        title: "Project Manager",
        department: "Operations",
        location: "Muscat, Oman",
        type: "Full-time",
        experience: "5-7 years",
        description: "Oversee smart city projects from conception to completion, ensuring timely delivery and client satisfaction.",
        skills: ["Project Management", "Agile", "Stakeholder Management", "Budget Planning"]
      },
      {
        id: 3,
        title: "AI/ML Specialist",
        department: "R&D",
        location: "Muscat, Oman",
        type: "Full-time",
        experience: "2-4 years",
        description: "Develop machine learning algorithms for traffic optimization, predictive maintenance, and smart city analytics.",
        skills: ["Machine Learning", "Python", "TensorFlow", "Computer Vision", "Data Science"]
      },
      {
        id: 4,
        title: "Sales Engineer",
        department: "Sales",
        location: "Muscat, Oman",
        type: "Full-time",
        experience: "2-3 years",
        description: "Drive business growth by identifying opportunities and presenting technical solutions to government and private clients.",
        skills: ["Technical Sales", "Presentation", "Client Relations", "Smart City Solutions"]
      }
    ]
  },

  projects: [
    {
      id: 1,
      title: "Smart Lighting Network",
      category: "lighting",
      description: "Comprehensive smart lighting implementation across Muscat's main corridors, featuring IoT-enabled LED.",
      overview: "This project involved the installation of 2,500 smart LED street lights across Muscat's primary road network. The system includes real-time monitoring, automated dimming based on traffic patterns, and predictive maintenance capabilities.",
      image: process.env.PUBLIC_URL + "/Website_Work/01_Smart_Lighting/A9-Noord-Holland-Netherlands-IZYLUM-EXEDRA-Schreder-11.jpg",
      technologies: ["IoT Sensors", "Cloud Computing", "LED Technology", "Mobile App"],
      features: [
        "Real-time monitoring and control",
        "Automated dimming schedules",
        "Predictive maintenance alerts",
        "Energy consumption analytics",
        "Mobile app for maintenance teams"
      ],
      results: {
        energySaved: "70%",
        costReduction: "45%",
        improvement: "85%"
      },
      testimonial: "TSI's smart lighting solution has transformed our city's infrastructure. The energy savings alone have exceeded our expectations, and the system's reliability has been outstanding.",
      location: "Muscat, Oman",
      duration: "14 months",
      client: "Muscat Municipality",
      clientPosition: "Director of Infrastructure"
    },
    {
      id: 2,
      title: "Traffic Enforcement System",
      category: "traffic",
      description: "Advanced LIDAR-based speed enforcement system with multi-lane detection capabilities and real-time violation processing.",
      overview: "Deployed state-of-the-art LIDAR technology for comprehensive traffic enforcement across Salalah's highway network. The system can track multiple vehicles simultaneously and operates effectively in all weather conditions.",
      image: process.env.PUBLIC_URL + "/Website_Work/02_Traffic_Enforcement/Slide1.JPG",
      technologies: ["LIDAR Technology", "AI Processing", "Real-time Analytics", "Mobile Units"],
      features: [
        "75-meter detection range",
        "Multi-lane vehicle tracking",
        "Weather-resistant operation",
        "Real-time violation processing",
        "Mobile enforcement units"
      ],
      results: {
        energySaved: "60%",
        costReduction: "30%",
        improvement: "90%"
      },
      testimonial: "The traffic enforcement system has significantly improved road safety in Salalah. Violation rates have decreased by 40% since implementation.",
      location: "Salalah, Oman",
      duration: "9 months",
      client: "Royal Oman Police - Dhofar Region",
      clientPosition: "Traffic Safety Commander"
    },
    {
      id: 3,
      title: "City Monitoring Network",
      category: "monitoring",
      description: "360-degree AI camera network providing comprehensive city monitoring and traffic management capabilities.",
      overview: "Installed a network of AI-powered cameras across Nizwa's city center, providing real-time monitoring of traffic flow, pedestrian safety, and urban management. The system integrates with the city's traffic control center for optimized management.",
      image: process.env.PUBLIC_URL + "/Website_Work/03_City_Monitoring/01_Final_one.jpg",
      technologies: ["AI Cameras", "Computer Vision", "Real-time Processing", "Control Center Integration"],
      features: [
        "360-degree coverage",
        "AI-powered analytics",
        "Real-time traffic monitoring",
        "Pedestrian safety detection",
        "Control center integration"
      ],
      results: {
        energySaved: "50%",
        costReduction: "35%",
        improvement: "75%"
      },
      testimonial: "The monitoring system has revolutionized how we manage traffic and urban safety in Nizwa. The AI capabilities provide insights we never had before.",
      location: "Nizwa, Oman",
      duration: "11 months",
      client: "Nizwa Municipality",
      clientPosition: "Traffic Management Director"
    },
    {
      id: 4,
      title: "Solar Street Lighting",
      category: "solar",
      description: "Sustainable solar-powered street lighting system reducing carbon footprint while providing reliable illumination.",
      overview: "Implemented a comprehensive solar street lighting system across Sohar's residential areas. The project includes solar panels, battery storage, and smart controllers for optimal energy management.",
      image: process.env.PUBLIC_URL + "/Website_Work/04_Solar_street_light/solar_solution_final.jpg",
      technologies: ["Solar Panels", "Battery Storage", "Smart Controllers", "Weather Monitoring"],
      features: [
        "100% solar powered",
        "Weather-resistant design",
        "Automatic brightness control",
        "Remote monitoring",
        "Low maintenance requirements"
      ],
      results: {
        energySaved: "100%",
        costReduction: "80%",
        improvement: "95%"
      },
      testimonial: "The solar lighting project aligns perfectly with our sustainability goals. It's been operating flawlessly for over a year with zero maintenance issues.",
      location: "Sohar, Oman",
      duration: "7 months",
      client: "Sohar Municipality",
      clientPosition: "Environmental Projects Manager"
    },
    {
      id: 5,
      title: "Facade Lighting Project",
      category: "lighting",
      description: "Energy-efficient LED facade lighting for historical monuments and cultural sites, enhancing tourism and cultural preservation.",
      overview: "Designed and implemented specialized LED lighting for Sur's historical monuments and cultural sites. The system includes projection mapping capabilities for cultural events and tourism enhancement.",
      image: process.env.PUBLIC_URL + "/Website_Work/05_Facade_lighting/pexels-ricky-rijan-2193300.jpg",
      technologies: ["LED Technology", "Projection Mapping", "Smart Controllers", "Cultural Event Integration"],
      features: [
        "Monument lighting",
        "Projection mapping",
        "Cultural event integration",
        "Energy-efficient design",
        "Tourism enhancement"
      ],
      results: {
        energySaved: "65%",
        costReduction: "40%",
        improvement: "90%"
      },
      testimonial: "The facade lighting has transformed Sur's cultural sites into beautiful landmarks. Tourism has increased by 25% since the project completion.",
      location: "Sur, Oman",
      duration: "5 months",
      client: "Ministry of Heritage and Tourism",
      clientPosition: "Cultural Sites Development Director"
    },
    {
      id: 6,
      title: "Smart Solar Poles",
      category: "solar",
      description: "Integrated smart poles combining solar power, LED lighting, IoT sensors, and wireless charging capabilities.",
      overview: "Deployed cutting-edge smart solar poles across Al Buraimi's city center. Each pole integrates multiple smart city functions including lighting, environmental monitoring, and wireless charging stations.",
      image: process.env.PUBLIC_URL + "/Website_Work/05_Smart_Solar_Pole/01_Solar_Smart_Pole.png",
      technologies: ["Solar Integration", "IoT Sensors", "Wireless Charging", "Environmental Monitoring"],
      features: [
        "Multi-function integration",
        "Wireless charging stations",
        "Environmental sensors",
        "Smart city connectivity",
        "Modular design"
      ],
      results: {
        energySaved: "85%",
        costReduction: "60%",
        improvement: "95%"
      },
      testimonial: "The smart poles are a game-changer for Al Buraimi. They've become the centerpiece of our smart city initiative and residents love the convenience.",
      location: "Al Buraimi, Oman",
      duration: "8 months",
      client: "Al Buraimi Municipality",
      clientPosition: "Director of Smart City Development"
    },
    {
      id: 7,
      title: "Emergency Vehicle Light Bar System",
      category: "safety",
      description: "High-performance LED light bars for emergency and patrol vehicles with customizable configurations and weather-resistant design.",
      overview: "Implemented advanced LED light bar systems across Royal Oman Police fleet vehicles. The project equipped over 150 patrol cars with state-of-the-art warning and signaling systems featuring smart controls, emergency mode activation, and integration with vehicle communication systems.",
      image: process.env.PUBLIC_URL + "/Website_Work/06_Light_Bar/Light_Bar.png",
      technologies: ["LED Technology", "Smart Controllers", "Vehicle Integration", "Emergency Response Systems"],
      features: [
        "High-intensity LED arrays",
        "Multiple flash patterns",
        "Customizable color configurations",
        "Weather and impact resistant",
        "Low power consumption",
        "Emergency mode automation"
      ],
      results: {
        energySaved: "55%",
        costReduction: "40%",
        improvement: "92%"
      },
      testimonial: "The new light bar systems have significantly enhanced our emergency response capabilities. The visibility and reliability of these units are exceptional, and the energy efficiency is a major benefit.",
      location: "Muscat, Oman",
      duration: "6 months",
      client: "Royal Oman Police",
      clientPosition: "Fleet Operations Manager"
    },
    {
      id: 8,
      title: "EV Charging Infrastructure Network",
      category: "charging",
      description: "Comprehensive DC fast charging network for electric vehicles with smart grid integration and remote monitoring capabilities.",
      overview: "Established a network of 25 DC fast charging stations across Muscat's main highways and commercial districts. Each station features multiple charging ports supporting various EV standards, integrated payment systems, real-time availability monitoring, and cloud-based management platform.",
      image: process.env.PUBLIC_URL + "/Website_Work/07_DC_Fast_EV_Charger/01_Final_one.png",
      technologies: ["DC Fast Charging", "Smart Grid Integration", "Cloud Platform", "Payment Systems", "Mobile App"],
      features: [
        "150kW rapid charging capability",
        "Multiple connector standards (CCS, CHAdeMO)",
        "Real-time availability tracking",
        "Integrated payment systems",
        "Remote monitoring and diagnostics",
        "Solar power integration options"
      ],
      results: {
        energySaved: "0%",
        costReduction: "25%",
        improvement: "88%"
      },
      testimonial: "TSI's EV charging network has been instrumental in supporting Oman's transition to electric mobility. The stations are reliable, user-friendly, and the smart features make fleet management seamless.",
      location: "Muscat, Oman",
      duration: "12 months",
      client: "Oman Energy Authority",
      clientPosition: "Sustainable Transport Director"
    },
    {
      id: 9,
      title: "Renewable Energy Storage System",
      category: "energy",
      description: "Advanced battery storage solutions for renewable energy integration and backup power for critical traffic infrastructure.",
      overview: "Deployed a comprehensive battery energy storage system (BESS) for Duqm's traffic control network. The 500kWh system integrates with existing solar installations to provide 24/7 reliable power for traffic signals, monitoring cameras, and communication equipment while stabilizing the local grid.",
      image: process.env.PUBLIC_URL + "/Website_Work/09_Battary_power/battery.png",
      technologies: ["Lithium-ion Battery Storage", "Smart Energy Management", "Grid Integration", "Renewable Energy Systems"],
      features: [
        "500kWh storage capacity",
        "Seamless grid integration",
        "Renewable energy optimization",
        "24/7 backup power capability",
        "Real-time energy management",
        "Predictive maintenance systems"
      ],
      results: {
        energySaved: "75%",
        costReduction: "55%",
        improvement: "93%"
      },
      testimonial: "The battery storage system has transformed our infrastructure reliability. We now have uninterrupted power for all critical systems, and the integration with our solar panels has dramatically reduced our operational costs.",
      location: "Duqm, Oman",
      duration: "10 months",
      client: "Duqm Special Economic Zone Authority",
      clientPosition: "Infrastructure Development Manager"
    }
  ]
};